const zh = {
  header: {
    tip1:
      "In order to prevent the system from accidentally closing the game in your virtual space, causing your game to be disconnected in unknown circumstances, you need to manually follow the following steps to complete the setting.",
  },
  content: {
    list1: {
      title:
        "Open the Settings of the phone, search for 'high power consumption in the background' and click 'high power consumption in the background'.Select the virtual master and turn it on to allow the application to run in the background.",
    },
    list2: {
      title:
        "When multi-process management state, add virtual master [lock] to keep the background running.- Search for [App Launch Management]",
    },
  },
};

export default zh;
